import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { Api } from './api';
import { AlertThickness } from '../models/alert-thickness.model';

@Injectable()
export class GeometricDataService {
  private endpoint: string = 'geometricData';

  constructor(private api: Api) {}

  getWing1LimitThicknessData(): Observable<AlertThickness> {
    return this.api.get(this.endpoint + '/alertThickness')
      .map(res => res.text() ? res.json() : null)
      .catch((error: any) => Observable.throw(error) || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/geometric-data.service.ts